import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=38f91f2c&scoped=true&"
import script from "./CharacterDetail.vue?vue&type=script&lang=js&"
export * from "./CharacterDetail.vue?vue&type=script&lang=js&"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&id=38f91f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f91f2c",
  null
  
)

export default component.exports